import { StandardPlot } from "../core/objects/svg/standard-plot";
import { OnlineDataPlotObjectGroup } from "./online-data-plot-object-group";

export class OnlineDataPlot extends StandardPlot {
  constructor(settings) {
    super(settings);
    this.onBufferSizeChanged = this._onSignalBoxBufferSizeChanged.bind(this);
  }

  init() {
    this.specificPlotObjects = new OnlineDataPlotObjectGroup(this);
    super.init();
    this.specificPlotObjects.startUpdateMeanValues();
  }

  beforeSignalObjectsCreate(channelSettings, channelContainer) {
    this.specificPlotObjects.createSignalsClickableAreas(channelSettings, channelContainer);
  }

  afterSignalObjectCreate(signalObject, dataSourceId, channelId, signalId) {
    this.specificPlotObjects.initUpdateMeanValueFunctions(signalObject, dataSourceId, channelId, signalId);
  }

  afterSignalsCreate(dataSourceId, channelId) {
    super.afterSignalsCreate(dataSourceId, channelId);
    this.specificPlotObjects.createChannelLeadRay(dataSourceId, channelId);
  }

  createBorders() {
    super.createBorders();
    this.specificPlotObjects.createSignalsClickableAreaBorders();
  }

  setOnBufferSizeChanged(action) {
    this.onBufferSizeChanged = () => {
      this._onSignalBoxBufferSizeChanged();
      action();
    };
  }

  _onSignalBoxBufferSizeChanged() {
    this.specificPlotObjects.clearEventObjects();
    this.clearSignalDependentMarks();
  }

  getChannelLead(dataSourceId, channelId) {
    return this.specificPlotObjects.getChannelLead(dataSourceId, channelId);
  }

  afterAddPointsToChannels(sourceId, channelId, blockSize, frameCounter) {
    this.specificPlotObjects.updateEventObjects(sourceId, channelId, blockSize, frameCounter);
  }

  addLineMark(data) {
    this.specificPlotObjects.addMark(data);
  }

  // points in user units (e.g. mV) or in pixels (if valueConverter is not set)
  afterAddPointsToSignal(dataSourceId, channelId /*, signalId*/) {
    this.specificPlotObjects.updateLeadRaysPosition(dataSourceId, channelId);
  }

  afterChannelsDataClear() {
    this.specificPlotObjects.setLeadRaysToZero();
    this.specificPlotObjects.clearEventObjects();
  }
}
